import { rgba } from 'polished';
import { IconButton } from 'shared/components/ui/icon-button';
import styled from 'styled-components';

export const Trigger = styled(IconButton)`
  opacity: 0;

  transition: opacity 0.15s ease;

  &:hover {
    background: ${({ theme }) => rgba(theme.palette.common.white, 0.1)};
  }
`;
